import React from 'react';

import { type SelectableOption } from '@/types/productSelectionAndCheckout/types';

const ViewOnlyProductOptions: React.FC<{
  selectableOptions: SelectableOption[];
}> = ({ selectableOptions }) => {
  return (
    <ul className="cur-flex cur-mb-0">
      {selectableOptions.map((selectableOption) => {
        return (
          <li key={selectableOption.fullSizeItemId}>
            <div
              className={`cur-border-2 cur-p-1 cur-rounded-full ${
                selectableOption.selected
                  ? 'cur-border-solid'
                  : 'cur-border-transparent'
              }`}
            >
              <div
                className="cur-h-4 cur-rounded-full cur-w-4"
                style={{
                  background: selectableOption.colorHex,
                }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ViewOnlyProductOptions;
